export default function ApproachSection() {
  const approaches = [
    {
      icon: 'ri-user-heart-line',
      title: 'Clinically Grounded Practice',
      description: 'Built on real rehabilitation experience.\nOver 10 years of hands-on work in mental health and recovery settings, not theoretical models alone.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trauma-Informed & Safety-Focused',
      description: 'Clear boundaries. Emotional safety.'
    },
    {
      icon: 'ri-brush-line',
      title: 'No Artistic Skills Required',
      description: 'No talent or creativity is needed — the focus is therapeutic processing, not artistic results.'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Individualized Therapeutic Process',
      description: 'Each session is adapted to the client\'s psychological state, recovery stage, and life context.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Practical Regulation Tools',
      description: 'Learn grounding, emotional regulation, and stabilization tools applicable outside therapy.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Long-Term, Sustainable Change',
      description: 'A structured therapeutic process aimed at resilience, clarity, and lasting recovery.'
    }
  ];

  return (
    <>
      {/* Section spacer */}
      <div className="cinematic-section-spacer"></div>
      
      <section id="art-therapy" className="py-20 lg:py-10 cinematic-bg-dark">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16 lg:mb-8">
            <h2 
              className="text-4xl lg:text-5xl font-bold cinematic-text-light mb-6"
            >
              My Approach to Therapy
            </h2>
            <p 
              className="text-lg md:text-xl cinematic-text-light opacity-80 max-w-3xl mx-auto leading-snug md:leading-relaxed mb-3 md:mb-6"
            >
              A clinically grounded therapeutic process focused on safety, regulation, and long-term recovery
            </p>
          </div>
          
          {/* Mobile: Single unified block, Desktop: Multi-column grid */}
          <div className="md:hidden">
            {/* Mobile: Single unified block with vertical list */}
            <div className="cinematic-bg-dark-alt p-6 rounded-2xl">
              <div className="space-y-6">
                {approaches.map((approach, index) => (
                  <div key={index} className="text-left">
                    <div className="w-10 h-10 cinematic-accent-bg rounded-full flex items-center justify-center mb-3">
                      <i className={`${approach.icon} text-lg text-white`}></i>
                    </div>
                    
                    <h3 
                      className="text-lg font-semibold cinematic-text-light mb-2"
                    >
                      {approach.title}
                    </h3>
                    
                    <p 
                      className="cinematic-text-light opacity-80 leading-relaxed text-sm whitespace-pre-line"
                    >
                      {approach.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Desktop: Multi-column grid */}
          <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-5">
            {approaches.map((approach, index) => (
              <div 
                key={index}
                className="cinematic-bg-dark-alt p-8 lg:p-5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border border-[#3a2a1e]"
              >
                <div className="w-16 h-16 lg:w-12 lg:h-12 cinematic-accent-bg rounded-full flex items-center justify-center mb-6 lg:mb-3">
                  <i className={`${approach.icon} text-2xl lg:text-xl text-white`}></i>
                </div>
                
                <h3 
                  className="text-xl lg:text-lg font-semibold cinematic-text-light mb-4 lg:mb-2"
                >
                  {approach.title}
                </h3>
                
                <p 
                  className="cinematic-text-light opacity-80 leading-relaxed whitespace-pre-line lg:text-sm"
                >
                  {approach.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
